module.exports = require('./helpers/bundle-url').getBundleURL('f6ego') + "logo-dark.eefe0b7f.svg";